<ui-info-field-item [label]="label">
  <ng-container *ngIf="items?.length; else notAvailableTemplate">
    <span *ngFor="let item of items; let isLast = last" class="field__text">
      {{ item | delimiter : delimiter.Comma : isLast }}
    </span>
  </ng-container>
</ui-info-field-item>
<ng-template #notAvailableTemplate>
  {{ notAvailable }}
</ng-template>
